import { Controller } from 'react-hook-form'
import { Radio } from '../../../../../components/Radio'

export const SwitchExpertType = ({ control, personType }: any) => {
  return (
    <div className="my-5">
      <Controller
        name="personType"
        control={control}
        render={({ field: { onChange } }) => (
          <Radio.Root
            name="personType"
            onChange={onChange}
            defaultValue={personType}
          >
            <p className="block text-xs lg:text-sm text-grey-800 my-2">
              Tipo de Expert
            </p>

            <div className="flex gap-10 text-xs lg:text-sm flex-wrap">
              <Radio.Item id="natural_person_type" value="natural_person">
                <Radio.Label htmlFor="natural_person_type">
                  Pessoa Física
                </Radio.Label>
              </Radio.Item>
              <Radio.Item id="legal_person_type" value="legal_person">
                <Radio.Label htmlFor="legal_person_type">
                  Pessoa Jurídica
                </Radio.Label>
              </Radio.Item>
              <Radio.Item
                id="international_person_type"
                value="international_person"
              >
                <Radio.Label htmlFor="international_person_type">
                  Internacional
                </Radio.Label>
              </Radio.Item>
            </div>
          </Radio.Root>
        )}
      />
    </div>
  )
}
